"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DashboardIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _material = require("@mui/material");

var _ramda = require("ramda");

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

var _faSearch = require("@fortawesome/pro-solid-svg-icons/faSearch");

var _faGift = require("@fortawesome/pro-solid-svg-icons/faGift");

var _faAtomAlt = require("@fortawesome/pro-solid-svg-icons/faAtomAlt");

var _faChevronUp = require("@fortawesome/pro-solid-svg-icons/faChevronUp");

var _faChevronDown = require("@fortawesome/pro-solid-svg-icons/faChevronDown");

var _faChevronRight = require("@fortawesome/pro-solid-svg-icons/faChevronRight");

var _faChevronLeft = require("@fortawesome/pro-solid-svg-icons/faChevronLeft");

var _faFlask = require("@fortawesome/pro-solid-svg-icons/faFlask");

var _faExclamationCircle = require("@fortawesome/pro-solid-svg-icons/faExclamationCircle");

var _faBan = require("@fortawesome/pro-solid-svg-icons/faBan");

var _faArrowRight = require("@fortawesome/pro-solid-svg-icons/faArrowRight");

var _faTruck = require("@fortawesome/pro-solid-svg-icons/faTruck");

var _faCheck = require("@fortawesome/pro-solid-svg-icons/faCheck");

var _faClock = require("@fortawesome/pro-solid-svg-icons/faClock");

var _faCog = require("@fortawesome/pro-solid-svg-icons/faCog");

var _faBoxFull = require("@fortawesome/pro-solid-svg-icons/faBoxFull");

var _faShippingFast = require("@fortawesome/pro-solid-svg-icons/faShippingFast");

var _faEnvelope = require("@fortawesome/pro-solid-svg-icons/faEnvelope");

var _faLevelUp = require("@fortawesome/pro-solid-svg-icons/faLevelUp");

var _faEye = require("@fortawesome/pro-solid-svg-icons/faEye");

var _faStar = require("@fortawesome/pro-solid-svg-icons/faStar");

var _faThumbsUp = require("@fortawesome/pro-solid-svg-icons/faThumbsUp");

var _faThumbsUp2 = require("@fortawesome/pro-light-svg-icons/faThumbsUp");

var _faThumbsDown = require("@fortawesome/pro-solid-svg-icons/faThumbsDown");

var _faThumbsDown2 = require("@fortawesome/pro-light-svg-icons/faThumbsDown");

var _faCalendarAlt = require("@fortawesome/pro-solid-svg-icons/faCalendarAlt");

var _faCalendar = require("@fortawesome/pro-solid-svg-icons/faCalendar");

var _faPlus = require("@fortawesome/pro-solid-svg-icons/faPlus");

var _faTimes = require("@fortawesome/pro-solid-svg-icons/faTimes");

var _faTimes2 = require("@fortawesome/pro-light-svg-icons/faTimes");

var _faTimes3 = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _faUsers = require("@fortawesome/pro-solid-svg-icons/faUsers");

var _faUser = require("@fortawesome/pro-solid-svg-icons/faUser");

var _faExternalLink = require("@fortawesome/pro-solid-svg-icons/faExternalLink");

var _faArrowLeft = require("@fortawesome/pro-solid-svg-icons/faArrowLeft");

var _faUserPlus = require("@fortawesome/pro-solid-svg-icons/faUserPlus");

var _faHistory = require("@fortawesome/pro-solid-svg-icons/faHistory");

var _faLightbulbOn = require("@fortawesome/pro-solid-svg-icons/faLightbulbOn");

var _faQuestionCircle = require("@fortawesome/pro-solid-svg-icons/faQuestionCircle");

var _faStore = require("@fortawesome/pro-solid-svg-icons/faStore");

var _faMagic = require("@fortawesome/pro-solid-svg-icons/faMagic");

var _faSlidersH = require("@fortawesome/pro-solid-svg-icons/faSlidersH");

var _faInfoCircle = require("@fortawesome/pro-solid-svg-icons/faInfoCircle");

var _faCommentsAlt = require("@fortawesome/pro-solid-svg-icons/faCommentsAlt");

var _faSave = require("@fortawesome/pro-solid-svg-icons/faSave");

var _faPencil = require("@fortawesome/pro-solid-svg-icons/faPencil");

var _faGraduationCap = require("@fortawesome/pro-solid-svg-icons/faGraduationCap");

var _faClipboardList = require("@fortawesome/pro-solid-svg-icons/faClipboardList");

var _faLaptop = require("@fortawesome/pro-solid-svg-icons/faLaptop");

var _faUserSecret = require("@fortawesome/pro-solid-svg-icons/faUserSecret");

var _faHome = require("@fortawesome/pro-solid-svg-icons/faHome");

var _faFileDownload = require("@fortawesome/pro-solid-svg-icons/faFileDownload");

var _faFileUpload = require("@fortawesome/pro-solid-svg-icons/faFileUpload");

var _faMinus = require("@fortawesome/pro-solid-svg-icons/faMinus");

var _faPlusCircle = require("@fortawesome/pro-solid-svg-icons/faPlusCircle");

var _faMinusCircle = require("@fortawesome/pro-solid-svg-icons/faMinusCircle");

var _faCaretRight = require("@fortawesome/pro-solid-svg-icons/faCaretRight");

var _faAngleDown = require("@fortawesome/pro-solid-svg-icons/faAngleDown");

var _faAngleDown2 = require("@fortawesome/pro-regular-svg-icons/faAngleDown");

var _faAngleUp = require("@fortawesome/pro-solid-svg-icons/faAngleUp");

var _faFilter = require("@fortawesome/pro-solid-svg-icons/faFilter");

var _faHeartRate = require("@fortawesome/pro-solid-svg-icons/faHeartRate");

var _faCheckCircle = require("@fortawesome/pro-solid-svg-icons/faCheckCircle");

var _faCircle = require("@fortawesome/pro-solid-svg-icons/faCircle");

var _faCheckSquare = require("@fortawesome/pro-solid-svg-icons/faCheckSquare");

var _faLongArrowDown = require("@fortawesome/pro-solid-svg-icons/faLongArrowDown");

var _faLongArrowUp = require("@fortawesome/pro-solid-svg-icons/faLongArrowUp");

var _faExclamationTriangle = require("@fortawesome/pro-solid-svg-icons/faExclamationTriangle");

var _faTelegramPlane = require("@fortawesome/free-brands-svg-icons/faTelegramPlane");

var _faFacebook = require("@fortawesome/free-brands-svg-icons/faFacebook");

var _faInstagram = require("@fortawesome/free-brands-svg-icons/faInstagram");

var _faLinkedin = require("@fortawesome/free-brands-svg-icons/faLinkedin");

var _faCopy = require("@fortawesome/pro-solid-svg-icons/faCopy");

var _faSpinner = require("@fortawesome/pro-solid-svg-icons/faSpinner");

var _faTwitter = require("@fortawesome/free-brands-svg-icons/faTwitter");

var _faPinterest = require("@fortawesome/free-brands-svg-icons/faPinterest");

var _faSalesforce = require("@fortawesome/free-brands-svg-icons/faSalesforce");

var _faRedoAlt = require("@fortawesome/pro-regular-svg-icons/faRedoAlt");

var _faAngleRight = require("@fortawesome/pro-solid-svg-icons/faAngleRight");

var _faAngleRight2 = require("@fortawesome/pro-regular-svg-icons/faAngleRight");

var _faMailBulk = require("@fortawesome/pro-regular-svg-icons/faMailBulk");

var _faListAlt = require("@fortawesome/pro-regular-svg-icons/faListAlt");

var _faChartPie = require("@fortawesome/pro-solid-svg-icons/faChartPie");

var _faFile = require("@fortawesome/pro-solid-svg-icons/faFile");

var _faPrint = require("@fortawesome/pro-solid-svg-icons/faPrint");

var _faSquare = require("@fortawesome/pro-solid-svg-icons/faSquare");

var _faSync = require("@fortawesome/pro-solid-svg-icons/faSync");

var _faEyeSlash = require("@fortawesome/pro-solid-svg-icons/faEyeSlash");

var _faFacebookSquare = require("@fortawesome/free-brands-svg-icons/faFacebookSquare");

var _faPinterestSquare = require("@fortawesome/free-brands-svg-icons/faPinterestSquare");

var _faYoutube = require("@fortawesome/free-brands-svg-icons/faYoutube");

var _faTwitterSquare = require("@fortawesome/free-brands-svg-icons/faTwitterSquare");

var _faPaperPlane = require("@fortawesome/pro-solid-svg-icons/faPaperPlane");

var _faVideo = require("@fortawesome/pro-solid-svg-icons/faVideo");

var _faHeart = require("@fortawesome/pro-solid-svg-icons/faHeart");

var _faHeart2 = require("@fortawesome/pro-regular-svg-icons/faHeart");

var _faImage = require("@fortawesome/pro-solid-svg-icons/faImage");

var _faMapMarkerAlt = require("@fortawesome/pro-solid-svg-icons/faMapMarkerAlt");

var _faLink = require("@fortawesome/pro-solid-svg-icons/faLink");

var _faGlobe = require("@fortawesome/pro-solid-svg-icons/faGlobe");

var _faLock = require("@fortawesome/pro-solid-svg-icons/faLock");

var _faTimesCircle = require("@fortawesome/pro-solid-svg-icons/faTimesCircle");

var _faSortAlphaUp = require("@fortawesome/pro-solid-svg-icons/faSortAlphaUp");

var _faSortAlphaDown = require("@fortawesome/pro-solid-svg-icons/faSortAlphaDown");

var _faSortAlphaDownAlt = require("@fortawesome/pro-solid-svg-icons/faSortAlphaDownAlt");

var _faSortAmountDown = require("@fortawesome/pro-solid-svg-icons/faSortAmountDown");

var _faSortAmountUp = require("@fortawesome/pro-solid-svg-icons/faSortAmountUp");

var _faSortNumericDown = require("@fortawesome/pro-solid-svg-icons/faSortNumericDown");

var _faSortNumericDownAlt = require("@fortawesome/pro-solid-svg-icons/faSortNumericDownAlt");

var _faSortNumericUp = require("@fortawesome/pro-solid-svg-icons/faSortNumericUp");

var _faSortAmountDownAlt = require("@fortawesome/pro-solid-svg-icons/faSortAmountDownAlt");

var _faLockAlt = require("@fortawesome/pro-solid-svg-icons/faLockAlt");

var _faTrashAlt = require("@fortawesome/pro-solid-svg-icons/faTrashAlt");

var _faExchangeAlt = require("@fortawesome/pro-solid-svg-icons/faExchangeAlt");

var _faFolderOpen = require("@fortawesome/pro-solid-svg-icons/faFolderOpen");

var _faBook = require("@fortawesome/pro-solid-svg-icons/faBook");

var _faIdCard = require("@fortawesome/pro-solid-svg-icons/faIdCard");

var _faShareSquare = require("@fortawesome/pro-solid-svg-icons/faShareSquare");

var _faPhone = require("@fortawesome/pro-solid-svg-icons/faPhone");

var _faStopwatch = require("@fortawesome/pro-solid-svg-icons/faStopwatch");

var _faPencilAlt = require("@fortawesome/pro-solid-svg-icons/faPencilAlt");

var _faListUl = require("@fortawesome/pro-solid-svg-icons/faListUl");

var _faCloudUploadAlt = require("@fortawesome/pro-solid-svg-icons/faCloudUploadAlt");

var _faArrowUp = require("@fortawesome/pro-solid-svg-icons/faArrowUp");

var _faCopy2 = require("@fortawesome/pro-regular-svg-icons/faCopy");

var _faSortUp = require("@fortawesome/pro-solid-svg-icons/faSortUp");

var _faSortDown = require("@fortawesome/pro-solid-svg-icons/faSortDown");

var _faSort = require("@fortawesome/pro-solid-svg-icons/faSort");

var _faSortAlt = require("@fortawesome/pro-solid-svg-icons/faSortAlt");

var _faMinusSquare = require("@fortawesome/pro-solid-svg-icons/faMinusSquare");

var _faCalendarTimes = require("@fortawesome/pro-solid-svg-icons/faCalendarTimes");

var _faCrown = require("@fortawesome/pro-solid-svg-icons/faCrown");

var _faTrash = require("@fortawesome/pro-solid-svg-icons/faTrash");

_fontawesomeSvgCore.library.add(_faExternalLink.faExternalLink, _faSearch.faSearch, _faGift.faGift, _faAtomAlt.faAtomAlt, _faChevronUp.faChevronUp, _faChevronDown.faChevronDown, _faChevronRight.faChevronRight, _faChevronLeft.faChevronLeft, _faFlask.faFlask, _faExclamationCircle.faExclamationCircle, _faBan.faBan, _faArrowRight.faArrowRight, _faTruck.faTruck, _faCheck.faCheck, _faClock.faClock, _faCog.faCog, _faBoxFull.faBoxFull, _faShippingFast.faShippingFast, _faEnvelope.faEnvelope, _faLevelUp.faLevelUp, _faEye.faEye, _faStar.faStar, _faThumbsUp.faThumbsUp, _faThumbsDown.faThumbsDown, _faCalendarAlt.faCalendarAlt, _faCalendar.faCalendar, _faPlus.faPlus, _faTimes.faTimes, _faTimes3.faTimes, _faUsers.faUsers, _faUser.faUser, _faArrowLeft.faArrowLeft, _faUserPlus.faUserPlus, _faHistory.faHistory, _faLightbulbOn.faLightbulbOn, _faQuestionCircle.faQuestionCircle, _faStore.faStore, _faMagic.faMagic, _faSlidersH.faSlidersH, _faInfoCircle.faInfoCircle, _faCommentsAlt.faCommentsAlt, _faSave.faSave, _faTelegramPlane.faTelegramPlane, _faPencil.faPencil, _faGraduationCap.faGraduationCap, _faClipboardList.faClipboardList, _faLaptop.faLaptop, _faUserSecret.faUserSecret, _faHome.faHome, _faFacebook.faFacebook, _faInstagram.faInstagram, _faLinkedin.faLinkedin, _faFileDownload.faFileDownload, _faFileUpload.faFileUpload, _faMinus.faMinus, _faPlusCircle.faPlusCircle, _faMinusCircle.faMinusCircle, _faCaretRight.faCaretRight, _faAngleDown.faAngleDown, _faAngleDown2.faAngleDown, _faAngleUp.faAngleUp, _faFilter.faFilter, _faHeartRate.faHeartRate, _faCheckCircle.faCheckCircle, _faCircle.faCircle, _faCheckSquare.faCheckSquare, _faExclamationTriangle.faExclamationTriangle, _faSalesforce.faSalesforce, _faCopy.faCopy, _faThumbsUp2.faThumbsUp, _faThumbsDown2.faThumbsDown, _faRedoAlt.faRedoAlt, _faAngleRight.faAngleRight, _faAngleRight2.faAngleRight, _faChartPie.faChartPie, _faFile.faFile, _faPrint.faPrint, _faSquare.faSquare, _faTwitter.faTwitter, _faPinterest.faPinterest, _faLongArrowDown.faLongArrowDown, _faLongArrowUp.faLongArrowUp, _faExclamationTriangle.faExclamationTriangle, _faCopy.faCopy, _faSpinner.faSpinner, _faLock.faLock, _faMailBulk.faMailBulk, _faListAlt.faListAlt, _faSync.faSync, _faEyeSlash.faEyeSlash, _faSync.faSync, _faFacebookSquare.faFacebookSquare, _faPinterestSquare.faPinterestSquare, _faYoutube.faYoutube, _faTwitterSquare.faTwitterSquare, _faTimes2.faTimes, _faTimes3.faTimes, _faPaperPlane.faPaperPlane, _faVideo.faVideo, _faImage.faImage, _faMapMarkerAlt.faMapMarkerAlt, _faLink.faLink, _faGlobe.faGlobe, _faTimesCircle.faTimesCircle, _faSortAlphaDown.faSortAlphaDown, _faSortAlphaDownAlt.faSortAlphaDownAlt, _faSortAlphaUp.faSortAlphaUp, _faSortAmountDown.faSortAmountDown, _faSortAmountUp.faSortAmountUp, _faLockAlt.faLockAlt, _faTrashAlt.faTrashAlt, _faExchangeAlt.faExchangeAlt, _faFolderOpen.faFolderOpen, _faBook.faBook, _faIdCard.faIdCard, _faShareSquare.faShareSquare, _faPhone.faPhone, _faStopwatch.faStopwatch, _faPencilAlt.faPencilAlt, _faListUl.faListUl, _faCloudUploadAlt.faCloudUploadAlt, _faArrowUp.faArrowUp, _faCopy2.faCopy, _faSort.faSort, _faSortUp.faSortUp, _faSortDown.faSortDown, _faMinusSquare.faMinusSquare, _faCalendarTimes.faCalendarTimes, _faHeart.faHeart, _faHeart2.faHeart, _faCrown.faCrown, _faSortAmountDownAlt.faSortAmountDownAlt, _faSortAlt.faSortAlt, _faSortNumericDown.faSortNumericDown, _faSortNumericDownAlt.faSortNumericDownAlt, _faSortNumericUp.faSortNumericUp, _faTrash.faTrash);
/**
 * @param {string} color
 * @param {object.<string, string>} palette
 * @returns {string}
 */


var getIconColor = function getIconColor(color, palette) {
  if (color === 'error') {
    return palette.error.main;
  }

  if (color === 'primary') {
    return palette.primary.main;
  }

  if (color === 'secondary') {
    return palette.secondary.main;
  }

  if (color === 'text') {
    return palette.text.secondary;
  }

  if (color === 'default') {
    return palette.green.dark;
  }

  if (color === 'default-light') {
    return palette.green.main;
  }

  if (color === 'default-salad') {
    return palette.green.fruitSalad;
  }

  if (color === 'link') {
    return palette.link.main;
  }

  if (color === 'white') {
    return palette.common.white;
  }

  if (color === 'grey') {
    return palette.grey.main;
  }

  if (color === 'orange') {
    return palette.orange.main;
  }

  if (color) {
    return (0, _ramda.pathOr)(color, (0, _ramda.split)('.', color), palette);
  }

  return 'inherit';
};
/**
 * @param {number | 'md' | 'lg' | 'sm'} size
 * @returns {string|number}
 */


var getIconSize = function getIconSize(size) {
  if (typeof size === 'number') {
    return String(size);
  }

  switch (size) {
    case 'lg':
      {
        return '2.5';
      }

    case 'md':
      {
        return '1.5';
      }

    case 'sm':
      {
        return '0.75';
      }

    default:
      {
        return '1.25';
      }
  }
};

var getIconWidth = function getIconWidth(width) {
  if (typeof width === 'number') {
    return "".concat(width, "px !important");
  }

  if (typeof width === 'string') {
    return "".concat(width, " !important");
  }

  return '';
};

var makeStyles = function makeStyles(_ref) {
  var _color = _ref.color,
      fontSize = _ref.fontSize,
      isDefaultCursor = _ref.isDefaultCursor,
      width = _ref.width;
  return {
    color: function color(_ref2) {
      var palette = _ref2.palette;
      return "".concat(getIconColor(_color, palette));
    },
    fontSize: "".concat(getIconSize(fontSize), "rem"),
    cursor: isDefaultCursor ? 'default' : 'pointer',
    width: getIconWidth(width) || null
  };
};

var StyledFontAwesomeIcon = (0, _material.styled)(_reactFontawesome.FontAwesomeIcon)({});

var Icon = function Icon(_ref3) {
  var className = _ref3.className,
      color = _ref3.color,
      fontSize = _ref3.fontSize,
      width = _ref3.width,
      _ref3$isDefaultCursor = _ref3.isDefaultCursor,
      isDefaultCursor = _ref3$isDefaultCursor === void 0 ? false : _ref3$isDefaultCursor,
      _ref3$sx = _ref3.sx,
      sx = _ref3$sx === void 0 ? [] : _ref3$sx,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["className", "color", "fontSize", "width", "isDefaultCursor", "sx"]);
  var styles = (0, _react.useMemo)(function () {
    return makeStyles({
      color: color,
      fontSize: fontSize,
      width: width,
      isDefaultCursor: isDefaultCursor
    });
  }, [color, fontSize, width, isDefaultCursor]);
  return /*#__PURE__*/_react["default"].createElement(StyledFontAwesomeIcon, (0, _extends2["default"])({}, props, {
    className: className,
    sx: [styles].concat((0, _toConsumableArray2["default"])(Array.isArray(sx) ? sx : [sx]))
  }));
};

Icon.propTypes = {
  icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,
  fontSize: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Icon.defaultProps = {
  fontSize: null,
  color: null,
  width: undefined,
  className: ''
};
/**
 * @deprecated
 *
 * @type {Icon}
 */

var DashboardIcon = Icon;
exports.DashboardIcon = DashboardIcon;
var _default = Icon;
exports["default"] = _default;